import { useState, Dispatch, SetStateAction } from 'react'
import TouchableOpacity from '../../TouchableOpacity'
import { startCapture } from '../../../helper/capture'
import styles from './style'

interface FormProps {
  display: boolean
  setDisplay: Dispatch<SetStateAction<boolean>>
  handleStartRecord?: () => void
  setIsCapturing: Dispatch<SetStateAction<boolean>>
}

function Form({ display, setDisplay, handleStartRecord = () => {}, setIsCapturing }: FormProps) {
  const [name, setName] = useState<string | null>(null)
  const [duration, setDuration] = useState<string | null>(null)
  const [stopOnFinish, setStopOnFinish] = useState(false)

  if (!display) return null

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div>
          <p>Capture settings</p>
          <label>
            Video name: <input onChange={e => setName(e.target.value)} />
          </label>
          <label>
            Capturing time:{' '}
            <input
              placeholder='In minutes'
              onChange={e => setDuration(e.target.value)}
              type='number'
            />
          </label>
          <label>
            Stop server:{' '}
            <input
              type='checkbox'
              checked={stopOnFinish}
              onChange={e => setStopOnFinish(e.target.checked)}
            />
          </label>
        </div>

        <div style={styles.buttonRow}>
          <TouchableOpacity
            onClick={() => {
              setDisplay(!display)
            }}
          >
            <p>CANCEL</p>
          </TouchableOpacity>
          <TouchableOpacity
            onClick={() => {
              console.log('DATA:')
              console.log(name)
              console.log(duration)
              startCapture({
                processName: 'ffmpegCaptureHD',
                fileName: name ?? undefined,
                duration: '' + duration,
                stopOnFinish,
                onSuccess: () => {
                  setIsCapturing(true)
                },
              })
              setDisplay(!display)
            }}
          >
            <p>START</p>
          </TouchableOpacity>
        </div>
      </div>
    </div>
  )
}

export default Form
